import { datasGatewayInterface } from '../../../corelogic/usecases/datas/datasGatewayInterface';
import { ELocalData } from '../../../corelogic/models/entities/datas/localData';
import { EConsoData } from '../../../corelogic/models/entities/datas/consoData';
import client from '../libs/client';
import currDateToTimeLimitsConverter from '../libs/CurrDateToTimeLimitsConverter';
import { t } from 'i18next';

export default class APIDatasGateway implements datasGatewayInterface {
  error: any;

  setError = (error: boolean) => {
    this.error = error;
  };

  getLocalProductionByInterval = async (
    participantId: number,
    interval: string,
    currentDate?: Date,
    dateFrom?: string,
    dateTo?: string,
  ): Promise<ELocalData[]> => {
    const myPart: ELocalData = new ELocalData(t('text.myShare'), -1);
    const otherPart: ELocalData = new ELocalData(t('text.othersShare'), -1);
    const surplusPart: ELocalData = new ELocalData(t('text.rejectedShare'), -1);
    const { from, to } = currDateToTimeLimitsConverter(interval, currentDate, dateFrom, dateTo);

    const { data: localDatas } = await client.get(
      `/participants/${participantId}/measurements/local-prod-by-interval`,
      {
        params: {
          dateFrom: from,
          dateTo: to,
        },
      },
    );
    const myPartValue = localDatas.find((elt: any) => elt.type === 'autoprod')?.energyMeasurement?.value || 0;
    myPart._value = Math.round(myPartValue);
    const otherPartValue =
      (localDatas.find((elt: any) => elt.type === 'global')?.energyMeasurement?.value || 0) - myPart._value;
    otherPart._value = Math.round(otherPartValue);
    const surplusValue = localDatas.find((elt: any) => elt.type === 'surplus')?.energyMeasurement?.value || 0;
    surplusPart._value = Math.round(surplusValue);

    return [myPart, otherPart, surplusPart];
  };

  getConso = async (
    participantId: number,
    interval: string,
    currentDate?: Date,
    dateFrom?: string,
    dateTo?: string,
  ): Promise<EConsoData[]> => {
    const { from, to } = currDateToTimeLimitsConverter(interval, currentDate, dateFrom, dateTo);
    function intervalMap() {
      switch (interval) {
        case t('words.day'):
          return 'heure';
        case t('words.month'):
          return 'jour';
        case t('words.year'):
          return 'mois';
        case t('words.period'):
          return 'jour';
        default:
          return 'heure';
      }
    }
    const config: any =
      interval && from && to
        ? {
            params: {
              interval: intervalMap(),
              dateFrom: from,
              dateTo: to,
            },
          }
        : {};
    const { data: autoconsoDatas } = await client.get(
      `/participants/${participantId}/measurements/conso-by-interval`,
      config,
    );
    return autoconsoDatas
      .filter((c: { date: string; power: number; powerACC: number }) => c.power !== null)
      .map((consoData: { date: string; power: number; powerACC: number }) => {
        return new EConsoData(consoData.date, consoData.power, consoData.powerACC);
      });
  };

  async getDateRanges(participantId: number): Promise<{ participantId: number; from: string; to: string }[]> {
    const { data: uploadedAndSgeTiersData } = await client.get(
      `/participants/${participantId}/measurements/date-ranges`,
    );
    return uploadedAndSgeTiersData.uploadedData;
  }
}
